@if (pageInfo?.urls?.length>1) {
<div class="breadcrumb-container">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <ol class="breadcrumb m-0 py-3">
          @for (url of pageInfo?.urls; track $index;let last = $last) {
          @if(!url.isDynamic) {
          @if (!last) {
          <li class="breadcrumb-item label-color cursor-pointer" (click)="redirectToPage(url)">
            <a>{{ url.title }}</a>
          </li>

          }
          } @else {
          @if (!last) {
          <li class="breadcrumb-item label-color cursor-pointer" (click)="redirectBack()">
            <a>{{ url.title }}</a>
          </li>
          }
          }
          @if (last) {
          <li class="breadcrumb-item text-info cursor-pointer">
            {{ url.title }}
          </li>
          }
          }
        </ol>
      </div>
    </div>
  </div>
</div>
}